// extracted by mini-css-extract-plugin
export default {"membertable_row":"PermissionUserRow_membertable_row__XGYa9"};